import * as React from "react";

import { Tooltip, message } from "antd";
import { EUrl, orderDetailUrl } from "utils/enum/url";
// 浏览器复制
import { CopyToClipboard } from "react-copy-to-clipboard";
import { TextAlignProperty } from "csstype";

import { formatDate } from "utils/tool";

// 订单列表中的账号字段

const showMessage = () => {
    message.config({
        duration: 1,
        maxCount: 1
    });
    message.info("复制成功");
};

// 判断显示复制图标
const showCopy = (taoAccount) => {
    // 淘宝账号有值时显示旺旺图标
    if (taoAccount) {
        return (
            <CopyToClipboard text={taoAccount}>
                <Tooltip title="点击复制到剪切板">
                    <a
                        onClick={showMessage}
                        style={{ padding: "0 8px", display: "inline-block" }}
                    >
                        <i className="list-link action-user action-fuzhi" />
                    </a>
                </Tooltip>
            </CopyToClipboard>
        );
    }
    return [];
};

// 判断显示旺旺图标
const showWangwang = (taoAccount) => {
    // 淘宝账号有值时显示旺旺图标
    if (taoAccount) {
        const url = EUrl.wangwang.replace("@var@", taoAccount);
        return (
            <Tooltip
                placement="top"
                title="跳转到旺旺"
            >
                <a href={url} target="_blank">
                    <i
                        className="action-user action-wangwang"
                        style={{ cursor: "pointer", color: "#2b9fbd" }}
                    />
                </a>
            </Tooltip>
        );
    }
    return [];
};
// 
const Accounts = (props) => {
    return <React.Fragment>
        {showCopy(props.record.account)}
        <span style={{ marginRight: 4 }}>
            <a
                className="list-link"
                href={"?account=" + props.record.account}
                target="_blank"
            //onClick={_searchAccount(record.account)}
            >
                {props.record.account || "-"}
            </a>
        </span>
        {showWangwang(props.record.account)}
    </React.Fragment>
}

const GroupStyle = {
    padding: "0 8px",
    display: "inline-block",
    cursor: "pointer"
};


const GroupNumber = (props) => {
    if (!props.text) {
        return <div style={{ width: "100%", textAlign: "center" as TextAlignProperty }}>
            -
      </div>
    }
    return <React.Fragment>
        <CopyToClipboard text={props.text}>
            <Tooltip title="点击复制到剪切板">
                <div onClick={showMessage} style={GroupStyle}>
                    <i className="action-user action-fuzhi" />
                    {props.text}
                </div>
            </Tooltip>
        </CopyToClipboard>
    </React.Fragment>
}

// 渲染日期
const RenderDate = (props) => {
    return <div style={{ padding: 8 }}>{formatDate(props.text)}</div>;
};

const RenderSkuName = (props) => {
    return <div style={{ padding: 8 }}>
        <a
            className="list-link"
            href={orderDetailUrl(EUrl.orderDetail, props.record.id)}
            target="_blank"
        >
            {props.text}
        </a>
    </div>
}

const SaleNumber = (props) => {
    return <React.Fragment>
        <span>{props.record.saleNum || 0}</span>/<span>{props.record.adultNum || 0}</span>/
    <span>{props.record.childrenNum || 0}</span>/
    <span>{props.record.babyNum || 0}</span>
    </React.Fragment>
}

export {
    Accounts,
    GroupNumber,
    RenderDate,
    RenderSkuName,
    SaleNumber
}